import { useCallback, useRef } from 'react';

export const useDelayedAction = <T extends any[]>(action: (...args: T) => void, delay: number, cancellable = true) => {
  const delayShowRef = useRef<number | null>(null);

  const cancel = useCallback(() => {
    if (cancellable && delayShowRef.current) {
      window.clearTimeout(delayShowRef.current);
    }
  }, [cancellable]);

  const delayed = useCallback(
    (...args: T) => {
      cancel();
      delayShowRef.current = window.setTimeout(() => action(...args), delay);
    },
    [action, cancel, delay]
  );

  return [delayed, cancel] as const;
};
